'use client';

import { useParams } from 'react-router-dom';
import GuideArticleClient from '../../components/guide-article-client';
import SharedGameFooter from '../../components/shared-game-footer';
import '../../components/game-guide-page.css';
import { useRegisteredGame } from '../use-registered-game';

/**
 * SPA 攻略详情：等 /api/games 解析出 game_key 后再拉帖子。
 * 爬虫仍走 vinext SSR（GuideArticleView + generateMetadata）。
 */
export default function SpaGuidePage({ legacy = true }: { legacy?: boolean }) {
  const params = useParams();
  const gameParam = String(params.game || '');
  const postId = String(params.postId || '');
  const registered = useRegisteredGame(gameParam);

  if (!gameParam || !postId) {
    return (
      <main className="spa-boot" role="alert">
        <h1>攻略不存在</h1>
        <p>
          <a href={`/${encodeURIComponent(gameParam || '')}`}>回首页</a>
        </p>
      </main>
    );
  }

  if (registered.status === 'loading') {
    return (
      <main className="spa-boot" aria-busy="true">
        <p className="spa-boot-status" />
      </main>
    );
  }

  if (registered.status === 'error') {
    return (
      <main className="spa-boot" role="alert">
        <h1>加载失败</h1>
        <p>{registered.message}</p>
        <p>
          <a href={`/${encodeURIComponent(gameParam)}`}>回首页</a>
        </p>
      </main>
    );
  }

  const gameKey = registered.game.key || gameParam;
  const domain = registered.game.domain || gameParam;

  return (
    <div className="game-page-layout">
      <div className="game-page-content">
        <GuideArticleClient
          key={`${gameKey}:${postId}`}
          gameKey={gameKey}
          gameDomain={domain}
          postId={postId}
          variant={legacy ? 'default' : 'v2'}
        />
      </div>
      <SharedGameFooter gameKey={domain} gameName={registered.game.name || gameParam} />
    </div>
  );
}
